import { Router } from '@angular/router';
import { AccessLevel, UserAccessService } from '@siza-staff-care/shared/app-state';
import { getCurrentSecurityMapping } from './root-route-to-security-mapping';
import { securityPaths } from './security-mappings';

/**
 * Uses the current root route to determine the security access level (Full, Read Only, None)
 * for the screen.
 * @param router
 * @param appState
 * @returns
 */
export const getAccessLevelForCurrentScreen = (router: Router, userAccess: UserAccessService): AccessLevel => {
	const securityMapping = getCurrentSecurityMapping(router, userAccess.appState);
	const path = securityPaths[securityMapping];
	const accessLevel = userAccess.getAccessLevelForControlPath(path);

	return accessLevel;
};
